import { render, staticRenderFns } from "./ExportationFrameTitle.vue?vue&type=template&id=3d640a2f&scoped=true&"
import script from "./ExportationFrameTitle.vue?vue&type=script&lang=ts&"
export * from "./ExportationFrameTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ExportationFrameTitle.vue?vue&type=style&index=0&id=3d640a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d640a2f",
  null
  
)

export default component.exports